module.exports = __webpack_public_path__ + "static/img/logo_big.835c851c.svg";